import React from 'react';
import { Box } from '@mui/material';
import BannerPrincipal from './components/BannerPrincipal'; // Asume que exportas el componente
import AccionesIngresoRapido from './components/AccionesIngresoRapido'; // Asume que exportas el componente
import TecnologiasYSuministros from './components/tecnology/TecnologiasYSuministros'; // Asume que exportas el componente
import CreacionContenidoIA from './components/CreacionContenidoIA'; // Asume que exportas el componente

const DashboardPrincipal = () => {
  return (
    <Box 
      sx={{ 
        px: ({ xs: 0, md: 1 }),
        py: 1,
        width: '100%', 
        mx: 'auto', // Centra el dashboard
      }}
    >
      
      {/* 1. Componente del Banner (incluye botones flotantes) */}
      <BannerPrincipal />
      
      {/* 2. Fila: Acciones de Ingreso Rápido */}
      <AccionesIngresoRapido />
      
      {/* 3. Fila: Tecnologías y Servicios (La "Fila Lila") */}
      <TecnologiasYSuministros />
      
      {/* 4. Fila: Creación de Contenido IA */}
      <CreacionContenidoIA />
      
    </Box>
  );
};

export default DashboardPrincipal;